import {
  AssignmentsViewOptions,
  MSAssignmentsStatusOptions,
} from 'src/interfaces/assignment.types';
import {
  ASSIGNMENT_STUDENT_HOME_SECTION,
  MS_ASSIGNMENT_STATUSES,
} from 'src/interfaces/event.types';

export const assignmentStudentHomeSections = {
  [AssignmentsViewOptions.TODO]: ASSIGNMENT_STUDENT_HOME_SECTION.todo,
  [AssignmentsViewOptions.PAST_WORK]: ASSIGNMENT_STUDENT_HOME_SECTION.pastWork,
};

export const msAssignmentStatuses = {
  [MSAssignmentsStatusOptions.STARTED]: MS_ASSIGNMENT_STATUSES.STARTED,
  [MSAssignmentsStatusOptions.NOT_STARTED]: MS_ASSIGNMENT_STATUSES.NOT_STARTED,
  [MSAssignmentsStatusOptions.HANDED_IN]: MS_ASSIGNMENT_STATUSES.HANDED_IN,
};
